export const getLaunchDarklyToken = () => {
  if (process.env.EXPO_PUBLIC_E2E_LAUNCHDARKLY_ENV === "prod") {
    return "611423c70b5b603f161aeaac"; // use prod key in CI
  }
  const host = window.location.host;

  if (host === "app.whoosh.io") {
    return "611423c70b5b603f161aeaac";
  } else if (host === "demo.whoosh.io") {
    return "6114270844cb563f30b95a16";
  } else if (host === "dev.whoosh.io") {
    return "6114272ab919584d0bd10bac";
  } else if (host === "qa.whoosh.io") {
    return "630fa14051ef5912161cf05d";
  } else if (host.includes("localhost") || host.includes("127.0.0.1")) {
    return "6114272ab919584d0bd10bac";
  } else {
    //Review App
    return "611427a38232090d6a29dad7";
  }
};
